import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import {
  insert_proforma_invoice_action,
  myOrders_list_action,
  order_cancel_reason_action,
  order_delete_action,
  download_performa_invoice_action,
} from "../../actions/myOrders_action/myOrders_action";
import "react-toastify/dist/ReactToastify.css";
import { Tab, Nav } from "react-bootstrap";
import Loader from "../../utils/Loader";
import { Modal, Button } from "react-bootstrap";
import { fill_action } from "../../actions/fillList_action";
import {
  cancellationReasonActionId,
  TypeOfEventActionId,
  downloadReport,
  toastError,
  sessionExpireMessage,
  tokenInavlidMessage,
} from "../../utils/constants";
import Header from "../../common_components/Header";
import Pagination from "../../utils/pagination";
import moment from "moment";
import DatePicker from "react-datepicker";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

const CustomInput = forwardRef(
  ({ value, onClick, onChange, disabled }, ref) => (
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      onChange={onChange}
      disabled={disabled}
      ref={ref}
    />
  )
);

class MyOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isAccordionExpanded: false,
      show: false,
      PiShow: false,
      deleteShow: false,
      cancelShow: false,
      editShow: false,
      is_release: false,
      userId: "",
      OrderID: "",
      CenterID: "",
      ClientID: "",
      FromDate: "",
      ToDate: "",
      StatusID: "",
      OrderDate: "",
      ItmeCenter: "",
      TypeOfEventID: "",
      TypeOfEvent: "",
      EventName: "",
      CompanyName: "",
      BookingDate: "",
      PrimaryEmailID: "",
      BlockedDate: "",
      ReceivedDate: "",
      OrderAmount: "",
      ConvenienceFee: "",
      RefundAmount: "",
      ProformaInvoice_No: "",
      currentPage: 1,
      MyOrdersData: [],
      proformaList: [],
      filteredData: [],
      eventFillList: [],
      CancellationReasonID: "",
      AdminRemark: "",
      cancelNote: "",
      cancellationReasonList: [],
      //dateRange
      dateRange: [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ],
      FromDate: "",
      ToDate: "",
    };
    this.onEditNavigate = this.onEditNavigate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.generateProforma = this.generateProforma.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  async componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate(
          "/login",
          this.props.params.status == "myOrder" && {
            state: { status: "myOrder" },
          }
        );
      }, 500);
    }

    sessionStorage.removeItem('formFile')
    sessionStorage.removeItem('membershipFormFileType')
    sessionStorage.removeItem('fileName')
    sessionStorage.removeItem('checkboxFlag')
    sessionStorage.removeItem('dummyMembershipFlag')
    sessionStorage.removeItem('newbookArray')
    sessionStorage.removeItem('bookArray')

    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 2 ? (
          this.props.navigate("/orders")
        ) : (
          <></>
        );
      }
    }, 10);

    sessionStorage.setItem("bookingArray_Is_Details", true);

    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    try {
      await this.myOrdersList();
      this.getFillList(cancellationReasonActionId, userId, "", "");
      this.getFillList(TypeOfEventActionId, userId, "", "");
    } catch (error) {
      console.error(error);
    }
  }

  async getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    try {
      const data = await this.props.fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      );
      console.log(data, "eventFillList");
      if (data.error != 1 && value == TypeOfEventActionId) {
        this.setState({ eventFillList: data.data, isLoading: false });
      }
      if (value == cancellationReasonActionId) {
        this.setState({ cancellationReasonList: data.data, isLoading: false });
        console.log("cancellationReasonActionId", data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }
  onPreviewNavigate(
    OrderID,
    OrderNo,
    ClientID,
    CompanyName,
    PrimaryEmailID,
    DeliveryStatus,
    CenterID
  ) {
    this.props.navigate("/my_orders_edit", {
      state: {
        OrderID: OrderID,
        OrderNo: OrderNo,
        ClientID: ClientID,
        CompanyName: CompanyName,
        PrimaryEmailID: PrimaryEmailID,
        DeliveryStatus: DeliveryStatus,
        CenterID: CenterID,
      },
    });
  }

  isDeleteShow(DeliveryStatus) {
    if (
      DeliveryStatus === "Cancelled" ||
      DeliveryStatus === "Cancellation Request" ||
      DeliveryStatus === "Delivered"
    ) {
      return false;
    }
    return true;
  }
  isEditShow(DeliveryStatus) {
    if (DeliveryStatus === "Incomplete") {
      return true;
    }
    return false;
  }

  isProformaShow(StatusID, Is_proforma, DeliveryStatus) {
    if (Is_proforma === false) {
      if (
        DeliveryStatus === "Confirmed" ||
        (DeliveryStatus === "Incomplete" && StatusID === 10)
      ) {
        return true; // Show the button
      }
    }
    return false; // Hide the button
  }

  onEditNavigate = (OrderID, OrderNo, StatusID, CenterID, BookingDate, ClientID) => {
    console.log(OrderID, OrderNo, StatusID, CenterID, BookingDate);

    if (StatusID === 1 || StatusID === 2 || StatusID === 3 || StatusID === 4) {
      this.props.navigate("");
    } else if (StatusID === 5) {
      this.props.navigate("/companyInfo", {
        state: { OrderID: OrderID, CenterID: CenterID, ClientID: ClientID },
      });
    } else if (StatusID === 6) {
      this.props.navigate("/BookingDetails", {
        state: { OrderID: OrderID, CenterID: CenterID, ClientID: ClientID },
      });
    } else if (StatusID === 7) {
      this.props.navigate("/additionalServices", {
        state: { OrderID: OrderID, CenterID: CenterID, ClientID: ClientID },
      });
    } else if (StatusID === 8) {
      this.props.navigate("/termsAndConditons", {
        state: { OrderID: OrderID, CenterID: CenterID, ClientID: ClientID },
      });
    } else if (StatusID === 9) {
      this.props.navigate("/summary", {
        state: { OrderID: OrderID, CenterID: CenterID, ClientID: ClientID },
      });
    } else if (StatusID === 10 || StatusID === 13) {
      this.props.navigate("/cart", {
        state: { OrderID: OrderID, CenterID: CenterID, ClientID: ClientID },
      });
    } else if (StatusID === 16) {
      sessionStorage.removeItem("navAgain");
      sessionStorage.setItem("Is_modify", true);
      sessionStorage.setItem("OrderID", OrderID);
      sessionStorage.setItem("OrderNo", OrderNo);
      sessionStorage.setItem("centerID", CenterID);
      this.props.navigate("/calenderView", {
        state: { date: BookingDate },
      });
    } else {
      this.props.navigate("");
    }
  };

  myOrdersList = async () => {
    const { OrderID,
      FromDate,
      ToDate, StatusID } = this.state;
    this.setState({ isLoading: true });

    try {
      const data = await this.props.myOrders_list_action(
        OrderID,
        FromDate,
        ToDate,
        StatusID
      );
      console.log(data, "from UI MyOrders");

      if (data.error !== 1) {
        this.setState({
          MyOrdersData: data.data,
          isLoading: false,
          currentpage: 1,
        });
      } else {
        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
          //after session expire.....................
          sessionStorage.clear()
          this.props.navigate('/normalView')
          setTimeout(() => {
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }, 500);
        } else {
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  chooseDate(item) {
    this.setState({ dateRange: [item.selection] })
    this.setState({
      FromDate: item.selection['startDate'] != null ? moment(item.selection['startDate']).format('YYYY-MM-DD') : <></>,
      ToDate: item.selection['endDate'] != null ? moment(item.selection['endDate']).format('YYYY-MM-DD') : <></>
    })
  }
  generateProforma(OrderID, Is_Receipt, Is_25percent) {
    this.setState({ isLoading: true });
    this.props
      .insert_proforma_invoice_action(OrderID, Is_Receipt, Is_25percent)
      .then((data) => {
        console.log(data, "submit");
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("Data Inserted Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.myOrdersList(); // Fetch the updated list of holidays
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  requestModalShow(
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    RoleID,
    OrderAmount,
    BookingDate
  ) {
    this.setState({
      cancelShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      CompanyName: CompanyName,
      PrimaryEmailID: PrimaryEmailID,
      RoleID: RoleID,
      OrderAmount: OrderAmount,
      BookingDate: BookingDate,
    });
    console.log(
      "deleteModal",
      OrderID,
      OrderNo,
      CompanyName,
      PrimaryEmailID,
      RoleID,
      OrderAmount,
      BookingDate
    );
  }
  requestModalClose() {
    this.setState({ cancelShow: false });
  }
  piModalShow(
    OrderID,
    OrderNo,
    ProformaInvoiceID,
    ProformaInvoice_No,
    ProformaType
  ) {
    // Splitting comma-separated values
    const idList = ProformaInvoiceID.split(",").map(Number);
    const noList = ProformaInvoice_No.split(",").map(String);
    const typeList = ProformaType.split(",").map(String);

    // Extracting Proforma details
    const proformaDetails = idList.map((id, index) => ({
      ProformaInvoiceID: id,
      ProformaInvoice_No: noList[index],
      ProformaType: typeList[index],
    }));

    console.log(OrderID, OrderNo, proformaDetails);

    this.setState({
      PiShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      proformaList: proformaDetails,
    });
  }
  piModalClose() {
    this.setState({ PiShow: false });
  }
  deleteModalShow(
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    DeliveryStatus
  ) {
    this.setState({
      deleteShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      CompanyName: CompanyName,
      PrimaryEmailID: PrimaryEmailID,
      DeliveryStatus: DeliveryStatus,
    });
    console.log("deleteModal", OrderID, OrderNo, CompanyName, PrimaryEmailID);
  }
  deleteModalClose() {
    this.setState({ deleteShow: false });
  }
  editModalShow(OrderID, OrderNo, StatusID, CenterID, BookingDate, ClientID) {
    this.setState({
      editShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      StatusID: StatusID,
      CenterID: CenterID,
      BookingDate: BookingDate,
      ClientID: ClientID,
    });
  }
  editModalClose() {
    this.setState({ editShow: false });
  }
  handleDeleteRequest(OrderID) {
    const {
      userId,
      OrderNo,
      CancellationReasonID,
      cancelNote,
      AdminRemark,
      CompanyName,
      PrimaryEmailID,
      RoleID,
      OrderAmount,
      ConvenienceFee,
      RefundAmount,
      BookingDate,
    } = this.state;
    this.setState({ isLoading: true });
    if (!CancellationReasonID) {
      toast.warning("Please select Cancellation Reason", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } else if (!cancelNote) {
      toast.warning("Kindly Fill Cancellation Note", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } else {
      this.props
        .order_cancel_reason_action(
          userId,
          OrderID,
          CancellationReasonID,
          cancelNote,
          AdminRemark,
          OrderNo,
          CompanyName,
          PrimaryEmailID,
          RoleID,
          OrderAmount,
          ConvenienceFee,
          RefundAmount
          // amountAfterDeduction
        )
        .then((data) => {
          if (data.error !== 1) {
            toast.success(
              `Your request to cancel the order ${OrderNo} has been submitted and send to the office. You will be intimated once approve.`,
              {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              }
            );
            this.requestModalClose();
            this.myOrdersList();
            this.setState({ isLoading: false });
          } else {
            if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  handleDelete(OrderID) {
    const { userId, OrderNo, CompanyName, PrimaryEmailID, DeliveryStatus } =
      this.state;
    this.setState({ isLoading: true });

    this.props
      .order_delete_action(
        userId,
        OrderID,
        OrderNo,
        CompanyName,
        PrimaryEmailID
      )
      .then((data) => {
        if (data.error !== 1) {
          toast.success(
            `Your request to cancel the order ${OrderNo} has been submitted and send to the office. You will be intimated once approve.`,
            {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            }
          );
          this.deleteModalClose();
          this.setState({ isLoading: false });
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }


  clearFilters = () => {
    window.location.reload();
  };

  downloadPerformaInvoice(ProformaInvoiceID, ProformaInvoice_No, ProformaType) {
    const { userId } = this.state;
    const formattedProformaInvoiceNo = ProformaInvoice_No.replace(
      /[\/-]/g,
      "_"
    );
    this.setState({ isLoading: true });

    if (ProformaInvoiceID) {
      console.log(ProformaInvoiceID, formattedProformaInvoiceNo);
      const selectedProformaType = ProformaType === 'Slot Booking' ? 1 : ProformaType === "Additionalservices" ? 1 : 0
      this.props
        .download_performa_invoice_action(
          userId,
          ProformaInvoiceID,
          formattedProformaInvoiceNo, selectedProformaType
        )
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);

            // Open the report in a new tab
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage) {
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored"
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot open: Proforma Invoice ID not found.", {
        position: "top-center", theme: "colored"
      });
    }
  }
  updateItem(item) {
    console.log("updateItem : ", item);
    this.setState({ currentPage: item });
  }
  ordersRecord(MyOrdersData) {
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUS</th>
                  <th>PROFORMA INVOICE</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {MyOrdersData.length > 0 ? (
                  MyOrdersData.map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      {console.log(data.OrderAmount, "data.OrderAmount")}
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus === "Pending for Verification" ? "Pending for Action" : data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate,
                                data.ClientID
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="11">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  incompleteRecord(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUS</th>
                  <th>PROFORMA INVOICE</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Incomplete").length > 0 ? (
                  filterOrdersByStatus("Incomplete").map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="11">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  verificationRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUSTUS</th>
                  <th>PROFORMA</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Pending for Verification").length > 0 ? (
                  filterOrdersByStatus("Pending for Verification").map(
                    (data) => (
                      <tr key={data.OrderID}>
                        {/* Render the rest of the table data for each row */}
                        <td>{data.OrderID}</td>
                        <td>{data.OrderNo}</td>
                        <td className="text-center">
                          {data.OrderDate
                            ? moment(data.OrderDate).format("DD-MM-YYYY")
                            : null}
                        </td>
                        <td>{data.ItmeCenter}</td>
                        <td
                          style={{
                            overflowX: "hidden",
                            maxWidth: "4rem",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            cursor: "pointer"
                          }}
                          title={data.BookingDate}
                        >
                          {data.BookingDate}
                        </td>
                        <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                        <td className="text-right">
                          {data.OrderAmount?.toLocaleString("en-IN") ||
                            data.OrderAmount}
                        </td>
                        <td className="text-center">
                          <span
                            className={
                              data.DeliveryStatus === "Incomplete"
                                ? "badge_soft_secondary"
                                : data.DeliveryStatus === "Confirmed"
                                  ? "badge_soft_success"
                                  : data.DeliveryStatus === "Cancelled"
                                    ? "badge_soft_danger"
                                    : data.DeliveryStatus === "Cancellation Request"
                                      ? "badge_soft_warning"
                                      : "badge_soft_done"
                            }
                          >
                            {data.DeliveryStatus === "Pending for Verification" ? "Pending for Action" : data.DeliveryStatus}
                          </span>
                        </td>
                        <td className="text-center">
                          {this.isProformaShow(
                            data.StatusID,
                            data.Is_proforma,
                            data.DeliveryStatus
                          ) ? (
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={() => {
                                this.generateProforma(data.OrderID, 0, 0);
                              }}
                            >
                              Generate
                            </button>
                          ) : data.ProformaInvoice_No?.length > 0 ? (
                            <a
                              title="Show Proforma"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.piModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.ProformaInvoiceID,
                                  data.ProformaInvoice_No,
                                  data.ProformaType
                                )
                              }
                            >
                              <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                            </a>
                          ) : null}
                        </td>
                        <td
                          className="text-right"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <a
                            title="View Order"
                            class="btn btn-sm padding_0"
                            onClick={() =>
                              this.onPreviewNavigate(
                                data.OrderID,
                                data.OrderNo,
                                data.ClientID,
                                data.CompanyName,
                                data.PrimaryEmailID,
                                data.DeliveryStatus,
                                data.CenterID
                              )
                            }
                          >
                            <i class="fa fa-eye action_btn_table"></i>
                          </a>

                          {this.isEditShow(data.DeliveryStatus) ? (
                            <a
                              title="Edit Order"
                              className="btn btn-sm padding_0"
                              data-toggle="modal"
                              data-target="#editOrder"
                              onClick={() =>
                                this.editModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.StatusID,
                                  data.CenterID,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-edit action_btn_table"></i>
                            </a>
                          ) : null}
                          {this.isDeleteShow(data.DeliveryStatus) ? (
                            data.DeliveryStatus === "Incomplete" ? (
                              <a
                                title="Cancel Order"
                                className="btn btn-sm delete_record"
                                onClick={() =>
                                  this.deleteModalShow(
                                    data.OrderID,
                                    data.OrderNo,
                                    data.CompanyName,
                                    data.PrimaryEmailID,
                                    data.DeliveryStatus
                                  )
                                }
                              >
                                <i className="fa fa-trash action_btn_table" />
                              </a>
                            ) : (
                              <a
                                title="Cancel Order"
                                className="btn btn-sm delete_record"
                                onClick={() =>
                                  this.requestModalShow(
                                    data.OrderID,
                                    data.OrderNo,
                                    data.CompanyName,
                                    data.PrimaryEmailID,
                                    data.RoleID,
                                    data.OrderAmount,
                                    data.BookingDate
                                  )
                                }
                              >
                                <i className="fa fa-trash action_btn_table" />
                              </a>
                            )
                          ) : null}
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="10">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  approvedRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUS</th>
                  <th>PROFORMA INVOICE</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Approved").length > 0 ? (
                  filterOrdersByStatus("Approved").map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="11">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  rejectedRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUS</th>
                  <th>PROFORMA INVOICE</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Rejected").length > 0 ? (
                  filterOrdersByStatus("Rejected").map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="11">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  confirmedRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUS</th>
                  <th>PROFORMA INVOICE</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Confirmed").length > 0 ? (
                  filterOrdersByStatus("Confirmed").map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="11">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  requestRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUSTUS</th>
                  <th>PROFORMA</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Cancellation Request").length > 0 ? (
                  filterOrdersByStatus("Cancellation Request").map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="10">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  cancelRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUS</th>
                  <th>PROFORMA INVOICE</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Cancelled").length > 0 ? (
                  filterOrdersByStatus("Cancelled").map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="11">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  deliveredRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUS</th>
                  <th>PROFORMA INVOICE</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Delivered").length > 0 ? (
                  filterOrdersByStatus("Delivered").map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="11">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  closureRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <div class="custom_table">
        <div class="hack1">
          <div class="hack2">
            <table className="table table-bordered table-striped">
              {/* Table header */}
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>APPLICATION NO.</th>
                  <th>ORDER NUMBER</th>
                  <th>ORDER DATE</th>
                  <th>ITME CENTER</th>
                  <th>BOOKING DATES</th>
                  <th>TYPE OF EVENT</th>
                  <th>ORDER AMOUNT</th>
                  <th>ORDER STATUS</th>
                  <th>PROFORMA INVOICE</th>
                  <th className="text-right" style={{ width: "9%" }}>
                    ACTION
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody>
                {filterOrdersByStatus("Closed").length > 0 ? (
                  filterOrdersByStatus("Closed").map((data) => (
                    <tr key={data.OrderID}>
                      {/* Render the rest of the table data for each row */}
                      <td>{data.OrderID}</td>
                      <td>{data.OrderNo}</td>
                      <td className="text-center">
                        {data.OrderDate
                          ? moment(data.OrderDate).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td>{data.ItmeCenter}</td>
                      <td
                        style={{
                          overflowX: "hidden",
                          maxWidth: "4rem",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "pointer"
                        }}
                        title={data.BookingDate}
                      >
                        {data.BookingDate}
                      </td>
                      <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                      <td className="text-right">
                        {data.OrderAmount?.toLocaleString("en-IN") ||
                          data.OrderAmount}
                      </td>
                      <td className="text-center">
                        <span
                          className={
                            data.DeliveryStatus === "Incomplete"
                              ? "badge_soft_secondary"
                              : data.DeliveryStatus === "Confirmed"
                                ? "badge_soft_success"
                                : data.DeliveryStatus === "Cancelled"
                                  ? "badge_soft_danger"
                                  : data.DeliveryStatus === "Cancellation Request"
                                    ? "badge_soft_warning"
                                    : "badge_soft_done"
                          }
                        >
                          {data.DeliveryStatus}
                        </span>
                      </td>
                      <td className="text-center">
                        {this.isProformaShow(
                          data.StatusID,
                          data.Is_proforma,
                          data.DeliveryStatus
                        ) ? (
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              this.generateProforma(data.OrderID, 0, 0);
                            }}
                          >
                            Generate
                          </button>
                        ) : data.ProformaInvoice_No?.length > 0 ? (
                          <a
                            title="Show Proforma"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.piModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.ProformaInvoiceID,
                                data.ProformaInvoice_No,
                                data.ProformaType
                              )
                            }
                          >
                            <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                          </a>
                        ) : null}
                      </td>
                      <td
                        className="text-right"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <a
                          title="View Order"
                          class="btn btn-sm padding_0"
                          onClick={() =>
                            this.onPreviewNavigate(
                              data.OrderID,
                              data.OrderNo,
                              data.ClientID,
                              data.CompanyName,
                              data.PrimaryEmailID,
                              data.DeliveryStatus,
                              data.CenterID
                            )
                          }
                        >
                          <i class="fa fa-eye action_btn_table"></i>
                        </a>

                        {this.isEditShow(data.DeliveryStatus) ? (
                          <a
                            title="Edit Order"
                            className="btn btn-sm padding_0"
                            data-toggle="modal"
                            data-target="#editOrder"
                            onClick={() =>
                              this.editModalShow(
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.BookingDate
                              )
                            }
                          >
                            <i className="fa fa-edit action_btn_table"></i>
                          </a>
                        ) : null}
                        {this.isDeleteShow(data.DeliveryStatus) ? (
                          data.DeliveryStatus === "Incomplete" ? (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.deleteModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.DeliveryStatus
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          ) : (
                            <a
                              title="Cancel Order"
                              className="btn btn-sm delete_record"
                              onClick={() =>
                                this.requestModalShow(
                                  data.OrderID,
                                  data.OrderNo,
                                  data.CompanyName,
                                  data.PrimaryEmailID,
                                  data.RoleID,
                                  data.OrderAmount,
                                  data.BookingDate
                                )
                              }
                            >
                              <i className="fa fa-trash action_btn_table" />
                            </a>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  // If MyOrdersData is empty, display a message or fallback content
                  <tr>
                    <td colSpan="11">No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  render() {
    const {
      isLoading,
      show,
      isOpen,
      userId,
      editShow,
      CenterID,
      BookingDate,
      isAccordionExpanded,
      MyOrdersData,
      OrderID,
      OrderNo,
      Date,
      OrderDate,
      ItmeCenter,
      StatusID,
      eventFillList,
      TypeOfEventID,
      EventName,
      TypeOfEvent,
      currentPage,
      startDate,
      endDate,
      deleteShow,
      cancelShow,
      CancellationReasonID,
      cancellationReasonList,
      cancelNote,
      AdminRemark,
      OrderAmount,
      ConvenienceFee,
      RefundAmount,
      key, PiShow, proformaList, ClientID
    } = this.state;
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = MyOrdersData.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsIncomplete = filterOrdersByStatus("Incomplete").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsVerification = filterOrdersByStatus(
      "Pending for Verification"
    ).slice(indexOfFirstRecord, indexOfLastRecord);
    const currentRecordsApproved = filterOrdersByStatus("Approved").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsRejected = filterOrdersByStatus("Rejected").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsConfirmed = filterOrdersByStatus("Confirmed").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );

    const currentRecordsRequest = filterOrdersByStatus(
      "Cancellation Request"
    ).slice(indexOfFirstRecord, indexOfLastRecord);

    const currentRecordsCancel = filterOrdersByStatus("Cancelled").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsDelivered = filterOrdersByStatus("Delivered").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsClosed = filterOrdersByStatus("Closed").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );

    const nPages = Math.ceil(MyOrdersData.length / recordsPerPage);
    const nPagesIncomplete = Math.ceil(
      filterOrdersByStatus("Incomplete").length / recordsPerPage
    );
    const nPagesVerification = Math.ceil(
      filterOrdersByStatus("Pending for Verification").length / recordsPerPage
    );
    const nPagesApproved = Math.ceil(
      filterOrdersByStatus("Approved").length / recordsPerPage
    );
    const nPagesRejected = Math.ceil(
      filterOrdersByStatus("Rejected").length / recordsPerPage
    );
    const nPagesConfirmed = Math.ceil(
      filterOrdersByStatus("Confirmed").length / recordsPerPage
    );

    const nPagesRequest = Math.ceil(
      filterOrdersByStatus("Cancellation Request").length / recordsPerPage
    );
    const nPagesCancel = Math.ceil(
      filterOrdersByStatus("Cancelled").length / recordsPerPage
    );
    const nPagesDelivered = Math.ceil(
      filterOrdersByStatus("Delivered").length / recordsPerPage
    );
    const nPagesClosed = Math.ceil(
      filterOrdersByStatus("Closed").length / recordsPerPage
    );
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[4]} />
            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">My Orders</h4>
                  {/* <div>
      <a href="#" class="btn btn-primary btn-sm create_btn" data-toggle="modal" data-target="#createRole">
          <i class="fa fa-plus"></i> <span class="hidden-xs">Add</span>
      </a>
    </div> */}
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          <h5>
                            Order Date :{" "}
                            <span>
                              {startDate}&nbsp; - &nbsp;{endDate}
                            </span>
                          </h5>
                          <h5>
                            Order No:
                            <span>{OrderNo}</span>
                          </h5>
                          <h5>
                            Center Name : <span>{ItmeCenter}</span>
                          </h5>
                          <h5>
                            Type Of Event : <span>{EventName}</span>
                          </h5>
                          <h5>
                            Status : <span></span>
                          </h5>
                          {/* <div class="chip">
              John Doe <span class="closebtn" onclick="this.parentElement.style.display='none'">&times;</span>
            </div> */}
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                          }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Order Date</label>
                                <DateRange
                                  editableDateInputs={true}
                                  onChange={(item) => this.chooseDate(item)}
                                  moveRangeOnFirstSelection={false}
                                  ranges={this.state.dateRange}
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Order No</label>
                                <input
                                  value={OrderNo}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      OrderNo: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  id="search"
                                  placeholder="Search for Center Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Itme Center</label>
                                <input
                                  value={ItmeCenter}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      ItmeCenter: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  id="search"
                                  placeholder="Search for Center Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Type Of Event</label>
                                <select
                                  className="form-control"
                                  value={EventName}
                                  onChange={(e) =>
                                    this.setState({
                                      EventName: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">Select</option>
                                  {eventFillList.length > 0
                                    ? eventFillList.map((data) => (
                                      <option
                                        key={data.TypeOfEventID}
                                        value={data.TypeOfEventID} // Store the TypeOfEventID
                                      >
                                        {data.EventName}
                                      </option>
                                    ))
                                    : null}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <label>&nbsp;</label>
                              <button
                                onClick={() => this.myOrdersList()}
                                className="btn btn-primary search_btn"
                              >
                                <i className="fa fa-sliders" />
                                Search
                              </button>
                              &nbsp;
                              <button
                                onClick={() => this.clearFilters()}
                                className="btn btn-primary search_btn"
                              >
                                <i className="fa fa-times" />
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row mr_0">
                    <div className="col-md-12 padding_0">
                      <Tab.Container defaultActiveKey="all">
                        <Nav
                          variant="tabs"
                          className="nav nav-tabs nav-tabs-custom nav-success mb-3 myOrderTabs"
                          role="tablist"
                        >
                          <Nav.Item>
                            <Nav.Link
                              eventKey="all"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-store-2-fill me-1 align-bottom" />{" "}
                              All Orders
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Incomplete"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-arrow-left-right-fill me-1 align-bottom" />{" "}
                              InComplete
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Pending for Verification"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-qr-scan-2-line me-1 align-bottom" />{" "}
                              Pending for Action
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Approved"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-check-fill me-1 align-bottom" />{" "}
                              Approved
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Rejected"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-close-line me-1 align-bottom" />{" "}
                              Rejected
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Confirmed"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-check-double-line me-1 align-bottom" />{" "}
                              Confirmed
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Cancellation Request"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-error-warning-line me-1 align-bottom" />{" "}
                              Cancellation Request
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="cancelled"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-close-circle-line me-1 align-bottom" />{" "}
                              Cancelled
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Delivered"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-checkbox-circle-line me-1 align-bottom" />{" "}
                              Delivered
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Closed"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-check-double-line me-1 align-bottom" />{" "}
                              Closed
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                        <Tab.Content>
                          {/* All Orders Tab */}
                          <Tab.Pane eventKey="all">
                            {this.ordersRecord(currentRecords)}
                            {MyOrdersData.length > 0 ? (
                              <Pagination
                                nPages={nPages}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                            <Modal
                              show={PiShow}
                              // onHide={()=>this.piModalClose()}
                              size="md"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Proforma Invoice for Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.piModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <h5>Proforma Invoice List</h5>

                                  <table className="table table-striped table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Sr.No</th>
                                        <th scope="col">
                                          Proforma Invoice No.
                                        </th>
                                        <th scope="col">
                                          Proforma Invoice Type
                                        </th>
                                        <th scope="col">Download</th>
                                      </tr>
                                    </thead>
                                    <tbody id="show_proformainvoices">
                                      {proformaList.length > 0 ? (proformaList.map((data, i) => (
                                        <tr key={data.ProformaInvoiceID}>
                                          <td colSpan="">{i + 1}</td>
                                          <td>{data.ProformaInvoice_No}</td>
                                          <td>
                                            {data.ProformaType === "Additionalservices" ? "Rental & Additional Services" : data.ProformaType ===
                                              ("Slot Booking") ? "Rental" : "Additional Amount"}
                                          </td>
                                          <td>
                                            <a
                                              title="Download Proforma"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                this.downloadPerformaInvoice(
                                                  data.ProformaInvoiceID,
                                                  data.ProformaInvoice_No, data.ProformaType
                                                )
                                              }
                                            >
                                              <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                                            </a>
                                          </td>
                                        </tr>
                                      ))) : (
                                        <tr>
                                          <td colSpan="4">No Proforma Details Found!</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() => this.piModalClose()}
                                >
                                  Close
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal
                              show={deleteShow}
                              // onHide={this.deleteModalClose}
                              size="md"
                            >
                              <Modal.Body>
                                <div class="form-group">
                                  <h5>
                                    Are you sure you want to Cancel this Order:{" "}
                                    {OrderNo}?
                                  </h5>
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() => this.handleDelete(OrderID)} // "SUBMIT" button
                                >
                                  Delete
                                </Button>
                                <Button
                                  variant="secondary"
                                  onClick={() => this.deleteModalClose()} // "SUBMIT" button
                                >
                                  close
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal
                              show={cancelShow}
                              // onHide={this.requestModalClose}
                              size="lg"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Cancel Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.requestModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <ul>
                                    <h5>CANCELLATION & REFUND</h5>
                                    <hr />
                                    <li>
                                      Once the ITME Center receives the online
                                      application forms for booking,
                                      cancellation of participation or reduction
                                      in requirements/packages will not be
                                      allowed after confirmation.
                                    </li>
                                    <li>
                                      If on any terms the event if canceled by
                                      the client then the cancellation charges
                                      will be as follows:
                                      <ol>
                                        <li>
                                          <strong>
                                            Event Cancelled 15 days prior – 25 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                        <li>
                                          <strong>
                                            Event Cancelled 10 days prior –75 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                        <li>
                                          <strong>
                                            Event Cancelled 5 days prior – 100 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                      </ol>
                                    </li>
                                    <li>
                                      The date on which written communication
                                      conveying full or partial cancellation is
                                      received by the Authority will be
                                      considered as the effective date for
                                      determining the cancellation charges.
                                    </li>
                                    <li>
                                      The advance amount / refundable amount and
                                      security deposit (if any) will be paid
                                      after deducting applicable taxes, banking
                                      charges, and administrative charges.
                                    </li>
                                  </ul>
                                </div>
                                <hr />
                                <div class="form-group">
                                  <label>Reason</label>
                                  <select
                                    id="country"
                                    name="Reason"
                                    value={CancellationReasonID}
                                    onChange={(e) => {
                                      const selectedReasonId = e.target.value;
                                      console.log(
                                        "Selected State ID:",
                                        selectedReasonId
                                      );

                                      this.setState({
                                        CancellationReasonID: selectedReasonId,
                                      });
                                    }}
                                    className="form-control floating-control"
                                  >
                                    <option value="">SELECT REASON</option>
                                    {cancellationReasonList.length > 0 &&
                                      cancellationReasonList.map((data) => (
                                        <option
                                          key={data.CancellationReasonID}
                                          value={data.CancellationReasonID}
                                        >
                                          {data.Name}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div class="form-group">
                                  <label>Cancellation Note</label>
                                  <textarea
                                    value={cancelNote}
                                    onChange={(e) =>
                                      this.setState({
                                        cancelNote: e.target.value,
                                      })
                                    }
                                    class="form-control"
                                    rows={3}
                                    defaultValue={""}
                                  />
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() =>
                                    this.handleDeleteRequest(OrderID)
                                  } // "SUBMIT" button
                                >
                                  Request
                                </Button>
                                <Button
                                  variant="warning"
                                  onClick={() =>
                                    this.requestModalClose()
                                  } // "SUBMIT" button
                                >
                                  Close
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal
                              show={editShow}
                              // onHide={this.editModalClose}
                              size="lg"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Modify Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.editModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <ol>
                                    <h5>Order Modification</h5>
                                    <hr />
                                    <li>
                                      Any postponement date is allowed only once
                                      after that you cannot change the date
                                    </li>
                                    <li>
                                      After the postponement/change of the date
                                      of the booking, you cannot cancel the
                                      booking.
                                    </li>
                                    <li>
                                      If you cancel the booking after the change
                                      of the date, your total amount will be
                                      forfeited.
                                    </li>
                                    <li>
                                      The change of booking date will be allowed
                                      only on the availability of the venue and
                                      on a first come first serve basis
                                    </li>
                                  </ol>
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() =>
                                    this.onEditNavigate(
                                      OrderID,
                                      OrderNo,
                                      StatusID,
                                      CenterID,
                                      BookingDate,
                                      ClientID
                                    )
                                  } // "SUBMIT" button
                                >
                                  Agree
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </Tab.Pane>

                          {/* In Progress Tab */}
                          <Tab.Pane eventKey="Incomplete">
                            {this.incompleteRecord(currentRecordsIncomplete)}
                            {filterOrdersByStatus("Incomplete").length > 0 ? (
                              <Pagination
                                nPages={nPagesIncomplete}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Pending for Verification Tab */}
                          <Tab.Pane eventKey="Pending for Verification">
                            {this.verificationRecords(
                              currentRecordsVerification
                            )}
                            {filterOrdersByStatus("Pending for Verification")
                              .length > 0 ? (
                              <Pagination
                                nPages={nPagesVerification}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Approved Tab */}
                          <Tab.Pane eventKey="Approved">
                            {this.approvedRecords(currentRecordsApproved)}
                            {filterOrdersByStatus("Approved").length > 0 ? (
                              <Pagination
                                nPages={nPagesApproved}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Rejected Tab */}
                          <Tab.Pane eventKey="Rejected">
                            {this.rejectedRecords(currentRecordsRejected)}
                            {filterOrdersByStatus("Rejected").length > 0 ? (
                              <Pagination
                                nPages={nPagesRejected}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* In Progress Tab */}
                          <Tab.Pane eventKey="Confirmed">
                            {this.confirmedRecords(currentRecordsConfirmed)}
                            {filterOrdersByStatus("Confirmed").length > 0 ? (
                              <Pagination
                                nPages={nPagesConfirmed}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Cancellation Request Tab */}
                          <Tab.Pane eventKey="Cancellation Request">
                            {this.requestRecords(currentRecordsRequest)}
                            {filterOrdersByStatus("cancellation Request")
                              .length > 0 ? (
                              <Pagination
                                nPages={nPagesRequest}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Cancelled Tab */}
                          <Tab.Pane eventKey="cancelled">
                            {this.cancelRecords(currentRecordsCancel)}
                            {filterOrdersByStatus("Cancelled").length > 0 ? (
                              <Pagination
                                nPages={nPagesCancel}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Delivered Tab */}
                          <Tab.Pane eventKey="Delivered">
                            {this.deliveredRecords(currentRecordsDelivered)}
                            {filterOrdersByStatus("Delivered").length > 0 ? (
                              <Pagination
                                nPages={nPagesDelivered}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Closed Tab */}
                          <Tab.Pane eventKey="Closed">
                            {this.closureRecords(currentRecordsClosed)}
                            {filterOrdersByStatus("Closed").length > 0 ? (
                              <Pagination
                                nPages={nPagesClosed}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    myOrders_list_action,
    fill_action,
    insert_proforma_invoice_action,
    download_performa_invoice_action,
    order_delete_action,
    order_cancel_reason_action,
  })(MyOrders)
);
